import { useParams } from 'react-router-dom';
import { all } from '../data/all';

function GenericFourthLevel() {
    const { country, first, second, third, fourth } = useParams();

    let countryData = [];
    
    all.forEach(thisCountry => {
        if (thisCountry.name.common === country) {
            countryData = JSON.stringify(thisCountry[first][second][third][fourth]);
        }
    })    

    return(
        <code>
            { countryData }
        </code>
    )
}

export default GenericFourthLevel;